import { currency } from '../../config';
import { QuoteModel } from '../../screens/NewQuotation/FinancialProductPage/financialProductPage.slice';
import { SearchVehicleResponse } from '../../services/redux/features/api/search-vehicle.slice';
import { VehicleType } from '../../types/vehicleTypeSelect';
import { formatMoney } from '../../utils/formatMoney/formatMoney';
import { additionalServicePlanInitialValues } from '../AdditionalServicePlan/initialValues';
import { CompareQuoteTableDataModel } from './compareQuotes.model';

const sanitize = <T>(value: T | null | undefined): T | string => value ?? '';

export const quotesMapper = (
  quotes: Array<QuoteModel>,
  isAdditionalServicePlanAdded: boolean,
  vehicle: SearchVehicleResponse,
  vehicleType: VehicleType
): Array<CompareQuoteTableDataModel> => {
  return quotes.map((quote) => {
    const productValues = quote.forms.financialProduct.values;
    const productSpecificationValues = quote.forms.financialProductSpecification.values;
    // TODO PC-3826 currenlty the old financial product page is not used
    // code below is kept because there will be one more similar page to add
    // it is filled with intial values for now, optionally to be removed in the future
    const servicePlanValues = additionalServicePlanInitialValues;
    const { vehicleData } = vehicle;

    return {
      quoteNumber: sanitize(quote.id),
      quoteVersion: sanitize(quote.version),
      invoicePrice: formatMoney(productSpecificationValues.invoicePrice ?? -1, currency),
      financeProduct: sanitize(productValues.productType),
      campaignName: sanitize(productValues.campaign),
      totalDepositPercentage: `${sanitize(productSpecificationValues.totalDepositPercentage)} %`,
      totalDepositEuro: formatMoney(productSpecificationValues.totalDeposit ?? -1, currency),
      amountFinanced: formatMoney(productSpecificationValues.amountFinanced ?? -1, currency),
      apr: `${sanitize(productSpecificationValues.totalApr)} %`,
      term: sanitize(productValues.term),
      monthlyPayment: formatMoney(productSpecificationValues.monthlyPayment ?? -1, currency),
      monthlyPaymentValid: productSpecificationValues.isQuoteValid || false,
      brand: sanitize(vehicleData.model?.manufacturer),
      model: sanitize(vehicleData.model?.name),
      variant: sanitize(vehicleData.model?.description),
      newUsed: vehicleType,
      servicePlanPrice: isAdditionalServicePlanAdded ? formatMoney(servicePlanValues.payment ?? -1, currency) : '-',
      servicePlanPriceValid: servicePlanValues.isQuoteValid || false,
      servicePlan: isAdditionalServicePlanAdded ? sanitize(servicePlanValues.servicePlanName) : '-',
      contractDuration: isAdditionalServicePlanAdded ? sanitize(servicePlanValues.contractDuration) : '-',
      paymentType: isAdditionalServicePlanAdded ? sanitize(servicePlanValues.paymentType) : '-',
      paymentTerm: isAdditionalServicePlanAdded ? sanitize(servicePlanValues.paymentTerm) : '-',
    };
  });
};
